export default "__VITE_ASSET__DBwaBk4___"